import script from "./UserDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserDetails.vue?vue&type=script&lang=ts&setup=true"

import "./UserDetails.vue?vue&type=style&index=0&id=7f54e108&lang=scss&scoped=true"
script.__scopeId = "data-v-7f54e108"

export default script